$(document).ready(() => {
  $(".bnr-slider-inner").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    buttons: true,
    dots: true,
    speed: 1000,
    cssEase: "ease-in-out",
    infinite: false,
  });
  $("[data-mute-switch]").click(function (e) {
    let video = $(this).closest(".banner-wrapper").find("video");
    let text = $(this).closest(".switch").siblings(".text");
    if (this.checked) {
      text.text("Unmuted");
      video[0].muted = false;
    } else {
      text.text("Muted");
      video[0].muted = true;
    }
  });
  $(".testimonial-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2500,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  if (window.location.href.includes("/pages/wser-100")) {
    $(".bwg-iwt-1,.section_bwg-yt-videos,.bwg-iwt-2").wrapAll(
      '<div class="common-bg-pattern"></div>'
    );
  }
  if (window.location.href.includes("/blogs/recipes")) {
    $(".recipe_section_iwt,.blog-main").wrapAll(
      '<div class="common-bg-pattern"></div>'
    );
  }
  if (window.location.href.includes("/pages/store-locator")) {
    $(".store-locator-main-wrap .section-header")
      .empty()
      .append(
        "<h2>Here you go! Use our store locator to see where you can find Stoked Oats near you.</h2>"
      )
      .removeClass("section-header")
      .addClass("section__heading");
  }

  // $(".quick_shop").click(function () {
  //   $("html").addClass("pdmodal_show");
  // });
  // $(".fancybox-close-small").click(function () {
  //   $("html").removeClass("pdmodal_show");
  // });

});
